import React, { useState, useEffect } from 'react';
import api from '../../api/api';
import AdminLayout from '../../components/AdminLayuot'; // ✅ Corregido nombre

const THEME = {
    primary: '#1F2937', secondary: '#3B82F6', success: '#10B981',
    warning: '#F59E0B', danger: '#EF4444', bg: '#F3F4F6',
    white: '#FFFFFF', border: '#E5E7EB'
};

const PRECIOS_FIELDS = [
    { key: 'precio_cafe_americano', label: 'Café Americano' },
    { key: 'precio_especialidad_chiapas', label: 'Esp. Chiapas' },
    { key: 'precio_especialidad_guerrero', label: 'Esp. Guerrero' },
    { key: 'precio_descafeinado', label: 'Descafeinado' },
    { key: 'precio_cafe_olla', label: 'Café de Olla' },
    { key: 'precio_cafe_ejecutivo', label: 'Mezcla Ejecutiva' }
];

const INITIAL_FORM = {
    username: '', email: '', password: '',
    firstName: '', lastName: '', razonSocial: '', rfc: '', direccionFiscal: '',
    precio_cafe_americano: 320, precio_especialidad_chiapas: 530, precio_especialidad_guerrero: 670,
    precio_descafeinado: 380, precio_cafe_olla: 250, precio_cafe_ejecutivo: 250
};

const INITIAL_STORE = { nombre: '', direccion: '', ciudad: '', telefono: '' };

function AdminClientes() {
    const [clientes, setClientes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    
    const [editingUser, setEditingUser] = useState(null); 
    const [isCreating, setIsCreating] = useState(false);
    const [viewingStores, setViewingStores] = useState(null); 
    const [isAddingStore, setIsAddingStore] = useState(false); 
    const [editingStoreId, setEditingStoreId] = useState(null); // Para saber si editamos sucursal
    const [newStoreData, setNewStoreData] = useState(INITIAL_STORE);
    
    const [activeTab, setActiveTab] = useState('DATOS'); 
    const [formData, setFormData] = useState(INITIAL_FORM);
    const [saving, setSaving] = useState(false);

    const fetchClientes = async () => {
        const token = localStorage.getItem('token');
        try {
            const { data } = await api.get('/users', { headers: { Authorization: `Bearer ${token}` } });
            setClientes(data.filter(u => u.rol === 'Cliente'));
        } catch (error) { console.error(error); } 
        finally { setLoading(false); }
    };

    useEffect(() => { fetchClientes(); }, []);

    // --- LOGICA DE CLIENTES ---

    const handleOpenCreate = () => {
        setFormData(INITIAL_FORM);
        setIsCreating(true);
        setEditingUser(true);
        setActiveTab('DATOS');
    };

    const handleEdit = (cliente, tabInicial = 'DATOS') => {
        setEditingUser(cliente);
        setIsCreating(false);
        setActiveTab(tabInicial);
        setFormData({
            username: cliente.username, email: cliente.email,
            firstName: cliente.perfil?.firstName || '',
            lastName: cliente.perfil?.lastName || '',
            razonSocial: cliente.perfil?.razonSocial || '',
            rfc: cliente.perfil?.rfc || '',
            direccionFiscal: cliente.perfil?.direccionFiscal || '',
            ...Object.fromEntries(PRECIOS_FIELDS.map(f => [f.key, cliente.perfil?.[f.key] || 0]))
        });
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        const token = localStorage.getItem('token');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        try {
            const profilePayload = {
                firstName: formData.firstName, lastName: formData.lastName,
                razonSocial: formData.razonSocial, rfc: formData.rfc, direccionFiscal: formData.direccionFiscal,
                ...Object.fromEntries(PRECIOS_FIELDS.map(f => [f.key, Number(formData[f.key])]))
            };
            if (isCreating) {
                const userRes = await api.post('/users', { username: formData.username, email: formData.email, password: formData.password, rol: 'Cliente' }, config);
                await api.post(`/profile/admin/${userRes.data.id}`, profilePayload, config);
                alert(`✅ Cliente creado`);
            } else {
                await api.patch(`/users/${editingUser.id}`, { username: formData.username, email: formData.email }, config);
                await api.patch(`/profile/admin/${editingUser.id}`, profilePayload, config);
                alert(`✅ Cambios guardados`);
            }
            setEditingUser(null);
            fetchClientes();
        } catch (error) { alert(`❌ Error: ${error.response?.data?.message}`); } 
        finally { setSaving(false); }
    };

    // --- LOGICA DE SUCURSALES (CRUD) ---

    const handleEditStoreClick = (sucursal) => {
        setNewStoreData({
            nombre: sucursal.nombre,
            direccion: sucursal.direccion,
            ciudad: sucursal.ciudad,
            telefono: sucursal.telefono || ''
        });
        setEditingStoreId(sucursal.id);
        setIsAddingStore(true);
    };

    const handleSaveStore = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        const currentClientId = viewingStores?.id;
        if (!currentClientId) return;

        try {
            if (editingStoreId) {
                await api.patch(`/sucursales/${editingStoreId}`, newStoreData, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                alert("✅ Sucursal actualizada");
            } else {
                await api.post('/sucursales', { ...newStoreData, usuarioId: currentClientId }, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                alert("✅ Sucursal agregada");
            }

            setIsAddingStore(false);
            setEditingStoreId(null);
            setNewStoreData(INITIAL_STORE);
            
            const { data } = await api.get('/users', { headers: { Authorization: `Bearer ${token}` } });
            const lista = data.filter(u => u.rol === 'Cliente');
            setClientes(lista);
            setViewingStores(lista.find(c => c.id === currentClientId));

        } catch (error) { alert("Error al procesar sucursal"); }
    };

    const handleDeleteStore = async (sucursalId) => {
        if (!window.confirm("¿Eliminar esta sucursal permanentemente?")) return;
        const token = localStorage.getItem('token');
        const currentClientId = viewingStores?.id;

        try {
            await api.delete(`/sucursales/${sucursalId}`, { headers: { Authorization: `Bearer ${token}` } });
            const { data } = await api.get('/users', { headers: { Authorization: `Bearer ${token}` } });
            const lista = data.filter(u => u.rol === 'Cliente');
            setClientes(lista);
            setViewingStores(lista.find(c => c.id === currentClientId));
            alert("🗑️ Sucursal eliminada");
        } catch (error) { alert("No se pudo eliminar"); }
    };

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
    const handleStoreChange = (e) => setNewStoreData({ ...newStoreData, [e.target.name]: e.target.value });

    const toggleStatus = async (cliente) => {
        if(!window.confirm(`¿Cambiar estado de ${cliente.username}?`)) return;
        try {
            await api.patch(`/users/${cliente.id}`, { isActive: !cliente.isActive }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            fetchClientes();
        } catch (error) { alert("Error"); }
    };

    const filtered = clientes.filter(c => 
        c.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.perfil?.razonSocial?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.email?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // --- ESTILOS ---
    const tableHeader = { textAlign: 'left', padding: 15, borderBottom: `2px solid ${THEME.border}`, color: '#6B7280', fontSize: 13, textTransform: 'uppercase' };
    const tableCell = { padding: 15, borderBottom: `1px solid ${THEME.border}`, color: THEME.primary, fontSize: 14, verticalAlign: 'middle' };
    const modalOverlay = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 };
    const modalContent = { background: 'white', borderRadius: 12, width: 600, maxWidth: '95%', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)', overflow: 'hidden', maxHeight: '90vh', display: 'flex', flexDirection: 'column' };
    const labelStyle = { display: 'block', fontSize: 12, fontWeight: 'bold', marginBottom: 5, color: '#374151' };
    const inputStyle = { width: '100%', padding: 10, borderRadius: 6, border: `1px solid ${THEME.border}`, marginBottom: 15 };

    if (loading) return <AdminLayout title="Clientes"><div style={{textAlign:'center', marginTop:50}}>Cargando directorio...</div></AdminLayout>;

    return (
        <AdminLayout title="Directorio de Clientes">
            <div style={{ marginBottom: 20, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <input 
                    type="text" placeholder="🔍 Buscar cliente..." 
                    style={{ padding: 12, borderRadius: 8, border: `1px solid ${THEME.border}`, width: 350 }}
                    value={searchTerm} onChange={e => setSearchTerm(e.target.value)}
                />
                <button onClick={handleOpenCreate} style={{ background: THEME.success, color: 'white', border: 'none', padding: '12px 24px', borderRadius: 8, fontWeight: 'bold', cursor: 'pointer' }}>+ Nuevo Cliente</button>
            </div>

            <div style={{ background: THEME.white, borderRadius: 12, boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 900 }}>
                    <thead>
                        <tr>
                            <th style={tableHeader}>Empresa / Usuario</th>
                            <th style={tableHeader}>Contacto</th>
                            <th style={tableHeader}>Tiendas</th>
                            <th style={tableHeader}>Estado</th>
                            <th style={tableHeader}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filtered.map(c => (
                            <tr key={c.id} style={{ background: c.isActive ? 'white' : '#F9FAFB', opacity: c.isActive ? 1 : 0.6 }}>
                                <td style={tableCell}>
                                    <div style={{fontWeight:'bold'}}>{c.perfil?.razonSocial || 'Sin Razón Social'}</div>
                                    <div style={{fontSize:12, color:'#6B7280'}}>{c.username}</div>
                                </td>
                                <td style={tableCell}>
                                    <div>{c.perfil?.firstName} {c.perfil?.lastName}</div>
                                    <div style={{fontSize:12, color:'#6B7280'}}>{c.email}</div>
                                </td>
                                <td style={tableCell}>
                                    <button onClick={() => setViewingStores(c)} style={{ background: '#EFF6FF', color: THEME.secondary, border: `1px solid ${THEME.secondary}30`, padding: '4px 12px', borderRadius: 15, fontSize: 12, fontWeight: 'bold', cursor: 'pointer' }}>
                                        📍 {c.sucursales?.length || 0} Tiendas
                                    </button>
                                </td>
                                <td style={tableCell}>
                                    <button onClick={() => toggleStatus(c)} style={{ background: c.isActive ? '#D1FAE5' : '#FEE2E2', color: c.isActive ? THEME.success : THEME.danger, border: 'none', padding: '4px 10px', borderRadius: 15, fontWeight: 'bold', fontSize: 11, cursor: 'pointer' }}>
                                        {c.isActive ? 'ACTIVO' : 'INACTIVO'}
                                    </button>
                                </td>
                                <td style={tableCell}>
                                    <div style={{display:'flex', gap: 5}}>
                                        <button onClick={() => handleEdit(c, 'DATOS')} style={{ background: THEME.bg, border: `1px solid ${THEME.border}`, padding: '6px 10px', borderRadius: 6, cursor: 'pointer' }}>✏️</button>
                                        <button onClick={() => handleEdit(c, 'PRECIOS')} style={{ background: THEME.secondary, color: 'white', border: 'none', padding: '6px 10px', borderRadius: 6, cursor: 'pointer' }}>💲</button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* MODAL DE SUCURSALES (CRUD COMPLETO) */}
            {viewingStores && (
                <div style={modalOverlay}>
                    <div style={modalContent}>
                        <div style={{ padding: 20, background: THEME.secondary, color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ margin: 0 }}>Sucursales de {viewingStores.perfil?.razonSocial || viewingStores.username}</h3>
                            <button onClick={() => {setViewingStores(null); setIsAddingStore(false); setEditingStoreId(null);}} style={{ background: 'transparent', border: 'none', color: 'white', fontSize: 24, cursor: 'pointer' }}>×</button>
                        </div>
                        <div style={{ padding: 20, overflowY: 'auto' }}>
                            {!isAddingStore ? (
                                <>
                                    <button onClick={() => { setIsAddingStore(true); setEditingStoreId(null); setNewStoreData(INITIAL_STORE); }} style={{ width: '100%', padding: 10, marginBottom: 20, background: THEME.success, color: 'white', border: 'none', borderRadius: 8, fontWeight: 'bold', cursor: 'pointer' }}>+ Agregar Sucursal</button>
                                    {viewingStores.sucursales?.map(s => (
                                        <div key={s.id} style={{ padding: 15, border: `1px solid ${THEME.border}`, borderRadius: 10, marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#F9FAFB' }}>
                                            <div>
                                                <div style={{ fontWeight: 'bold' }}>🏠 {s.nombre}</div>
                                                <div style={{ fontSize: 12, color: '#6B7280' }}>{s.direccion}, {s.ciudad}</div>
                                            </div>
                                            <div style={{ display: 'flex', gap: 10 }}>
                                                <button onClick={() => handleEditStoreClick(s)} style={{ border: 'none', background: 'none', cursor: 'pointer' }}>✏️</button>
                                                <button onClick={() => handleDeleteStore(s.id)} style={{ border: 'none', background: 'none', cursor: 'pointer' }}>🗑️</button>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            ) : (
                                <form onSubmit={handleSaveStore}>
                                    <h4 style={{marginTop: 0}}>{editingStoreId ? 'Editar Sucursal' : 'Nueva Sucursal'}</h4>
                                    <label style={labelStyle}>Nombre</label>
                                    <input name="nombre" value={newStoreData.nombre} onChange={handleStoreChange} style={inputStyle} required />
                                    <label style={labelStyle}>Dirección</label>
                                    <input name="direccion" value={newStoreData.direccion} onChange={handleStoreChange} style={inputStyle} required />
                                    <div style={{ display: 'flex', gap: 10 }}>
                                        <div style={{ flex: 1 }}><label style={labelStyle}>Ciudad</label><input name="ciudad" value={newStoreData.ciudad} onChange={handleStoreChange} style={inputStyle} required /></div>
                                        <div style={{ flex: 1 }}><label style={labelStyle}>Teléfono</label><input name="telefono" value={newStoreData.telefono} onChange={handleStoreChange} style={inputStyle} /></div>
                                    </div>
                                    <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
                                        <button type="button" onClick={() => {setIsAddingStore(false); setEditingStoreId(null);}} style={{ flex: 1, padding: 10, borderRadius: 8, border: `1px solid ${THEME.border}` }}>Cancelar</button>
                                        <button type="submit" style={{ flex: 1, padding: 10, background: THEME.success, color: 'white', border: 'none', borderRadius: 8, fontWeight: 'bold' }}>{editingStoreId ? 'Actualizar' : 'Guardar'}</button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL DE EDICIÓN / REGISTRO CLIENTE */}
            {editingUser && (
                <div style={modalOverlay}>
                    <div style={modalContent}>
                        <div style={{ padding: 20, background: THEME.primary, color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ margin: 0 }}>{isCreating ? 'Registrar Nuevo Cliente' : 'Editar Cliente'}</h3>
                            <button onClick={() => setEditingUser(null)} style={{ background: 'transparent', border: 'none', color: 'white', fontSize: 24, cursor: 'pointer' }}>×</button>
                        </div>
                        <div style={{ display: 'flex', borderBottom: `1px solid ${THEME.border}` }}>
                            <button onClick={() => setActiveTab('DATOS')} style={{ flex: 1, padding: 15, border: 'none', background: activeTab === 'DATOS' ? 'white' : '#F3F4F6', borderBottom: activeTab === 'DATOS' ? `3px solid ${THEME.secondary}` : 'none', cursor: 'pointer', fontWeight: 'bold' }}>📝 Datos</button>
                            <button onClick={() => setActiveTab('PRECIOS')} style={{ flex: 1, padding: 15, border: 'none', background: activeTab === 'PRECIOS' ? 'white' : '#F3F4F6', borderBottom: activeTab === 'PRECIOS' ? `3px solid ${THEME.secondary}` : 'none', cursor: 'pointer', fontWeight: 'bold' }}>💲 Precios</button>
                        </div>
                        <form onSubmit={handleSave} style={{ padding: 25, overflowY: 'auto' }}>
                            {activeTab === 'DATOS' && (
                                <>
                                    <div style={{ display: 'flex', gap: 15 }}>
                                        <div style={{ flex: 1 }}><label style={labelStyle}>Username</label><input name="username" value={formData.username} onChange={handleChange} style={inputStyle} required /></div>
                                        <div style={{ flex: 1 }}><label style={labelStyle}>Email</label><input name="email" type="email" value={formData.email} onChange={handleChange} style={inputStyle} required /></div>
                                    </div>
                                    {isCreating && (
                                        <><label style={labelStyle}>Contraseña Inicial</label><input name="password" type="password" value={formData.password} onChange={handleChange} style={inputStyle} required /></>
                                    )}
                                    <div style={{ display: 'flex', gap: 15 }}>
                                        <div style={{ flex: 1 }}><label style={labelStyle}>Nombre</label><input name="firstName" value={formData.firstName} onChange={handleChange} style={inputStyle} /></div>
                                        <div style={{ flex: 1 }}><label style={labelStyle}>Apellido</label><input name="lastName" value={formData.lastName} onChange={handleChange} style={inputStyle} /></div>
                                    </div>
                                    <label style={labelStyle}>Razón Social</label><input name="razonSocial" value={formData.razonSocial} onChange={handleChange} style={inputStyle} />
                                    <label style={labelStyle}>RFC</label><input name="rfc" value={formData.rfc} onChange={handleChange} style={inputStyle} />
                                    <label style={labelStyle}>Dirección Fiscal</label><input name="direccionFiscal" value={formData.direccionFiscal} onChange={handleChange} style={inputStyle} />
                                </>
                            )}
                            {activeTab === 'PRECIOS' && (
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 15 }}>
                                    {PRECIOS_FIELDS.map(item => (
                                        <div key={item.key}><label style={labelStyle}>{item.label} ($)</label><input type="number" step="0.50" name={item.key} value={formData[item.key]} onChange={handleChange} style={inputStyle} /></div>
                                    ))}
                                </div>
                            )}
                            <div style={{ marginTop: 20, display: 'flex', gap: 10 }}>
                                <button type="button" onClick={() => setEditingUser(null)} style={{ flex: 1, padding: 12, background: 'transparent', border: `1px solid ${THEME.border}`, borderRadius: 8 }}>Cancelar</button>
                                <button type="submit" disabled={saving} style={{ flex: 1, padding: 12, background: THEME.success, color: 'white', border: 'none', borderRadius: 8, fontWeight: 'bold' }}>{saving ? 'Guardando...' : (isCreating ? 'Registrar' : 'Guardar')}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </AdminLayout>
    );
}

export default AdminClientes;